import { useState } from "react";
import { navLinks } from "@/mocks/guaData";

export default function TopBar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 border-b border-background-200/70 bg-background-50/85 backdrop-blur">
      {/* 顶部细条：资讯门户工具条 */}
      <div className="border-b border-background-200/60 bg-background-100/70">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 md:px-6">
          <p className="truncate text-xs text-foreground-600">
            <span className="mr-1 text-primary-600">●</span>
            吃瓜m · 每天在线等一个真瓜，理性吃瓜，让子弹飞一会儿
          </p>
          <div className="hidden items-center gap-4 text-xs text-foreground-500 md:flex">
            <a href="#today" className="hover:text-primary-600">今日新瓜</a>
            <span className="text-background-300">|</span>
            <a href="#comment-talk" className="hover:text-primary-600">投稿爆料</a>
            <span className="text-background-300">|</span>
            <a href="#subscribe" className="hover:text-primary-600">蹲瓜提醒</a>
          </div>
        </div>
      </div>

      {/* 主导航 */}
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 md:px-6">
        <a href="#top" className="flex shrink-0 items-center gap-2" aria-label="吃瓜m 首页">
          <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 font-heading text-lg font-black leading-none text-background-50">
            瓜
          </span>
          <span className="font-heading text-xl font-black tracking-tight text-foreground-950">
            吃瓜<span className="text-primary-600">m</span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.key}
              href={link.href}
              className="whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium text-foreground-700 transition hover:bg-secondary-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <div className="relative hidden items-center md:flex">
            <i className="ri-search-line pointer-events-none absolute left-3 text-sm text-foreground-400" />
            <input
              type="text"
              aria-label="搜索瓜点"
              placeholder="搜一搜：这个瓜今天熟了吗"
              className="w-56 rounded-full border border-background-200 bg-background-50 py-2 pl-9 pr-4 text-sm text-foreground-900 outline-none transition placeholder:text-foreground-400 focus:border-primary-300 focus:ring-2 focus:ring-primary-200/60"
            />
          </div>
          <a
            href="#hot-rank"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition hover:bg-primary-600 sm:inline-flex"
          >
            刷热瓜
          </a>
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label="打开菜单"
            aria-expanded={open}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md text-foreground-800 transition hover:bg-secondary-100 lg:hidden"
          >
            <i className={`${open ? "ri-close-line" : "ri-menu-3-line"} text-xl`} />
          </button>
        </div>
      </div>

      {/* 移动端菜单 */}
      {open && (
        <nav className="menu-in border-t border-background-200/70 bg-background-50 px-4 py-3 lg:hidden" aria-label="移动端导航">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.key}
                href={link.href}
                onClick={() => setOpen(false)}
                className="whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium text-foreground-800 transition hover:bg-secondary-100"
              >
                {link.label}
              </a>
            ))}
            <div className="my-1 flex items-center gap-2 px-3 pt-2 md:hidden">
              <div className="relative flex flex-1 items-center">
                <i className="ri-search-line pointer-events-none absolute left-3 text-sm text-foreground-400" />
                <input
                  type="text"
                  aria-label="搜索瓜点"
                  placeholder="搜一搜最新瓜单"
                  className="w-full rounded-full border border-background-200 py-2 pl-9 pr-3 text-sm outline-none focus:border-primary-300"
                />
              </div>
            </div>
          </div>
        </nav>
      )}
    </header>
  );
}